import FeedOutlined from '@mui/icons-material/FeedOutlined';
import { Box } from '@/shared/ui';

import FactsheetDialogButtonBase from '@/features/factsheet/components/FactsheetDialogButton/FactsheetDialogButtonBase';
import Tooltip from '@/shared/ui/primitives/Tooltip';

const FactsheetDialogButton = ({
  code,
  fontSize = 16,
  mode,
  showTooltip = false
}: {
  code: string;
  fontSize?: number;
  mode?: 'modal' | 'newTab';
  showTooltip?: boolean;
}) => {
  const factsheetDialogButtonBase = (
    <FactsheetDialogButtonBase
      code={code}
      mode={mode}
    >
      <FeedOutlined sx={{ fontSize }} />
    </FactsheetDialogButtonBase>
  );

  if (showTooltip) {
    return (
      <Tooltip
        title='Click to see index information'
        variant='secondary'
      >
        <Box>{factsheetDialogButtonBase}</Box>
      </Tooltip>
    );
  }

  return factsheetDialogButtonBase;
};
export default FactsheetDialogButton;
